module.exports = __webpack_public_path__ + "static/img/gengxin2.120746c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/gengxin2.png
// module id = AIev
// module chunks = 24